export const INPUT_TYPES = {
  PARTICIPANT_BALANCE: "Participant Balance",
  PARTICIPANT: "Participant",
  PLAN_BASIC_DATA: "Plan Basic Data",
  AUTO_ENROLLMENT: "Auto Enrollment",
  AUTO_INCREASE: "Auto Increase",
  EMPLOYEE_CONTRIBUTION: "Employee Contribution",
  EMPLOYEE_MATCH: "Employee Match",
  EMPLOYEE_OTHER: "Employee Other",
  PRE_TAX_CONTRIBUTION: "Pre Tax Contribution",
  ROTH_CONTRIBUTION: "Roth Contribution",
  POST_TAX_CONTRIBUTION: "Post Tax Contribution",
  NQDC_CONTRIBUTION: "NQDC Contribution",
  COMPLIANCE_LIMIT: "Compliance Limit"
};
